import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'fitness-force-campaign-name',
  templateUrl: './campaign-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule, TooltipModule, TranslateModule]
})
export class CampaignNameComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null)
  constructor(private router :Router) { }

  ngOnInit(): void {
  }

  onGoToRoute(url:string, columnData:any){
    if(url)
     this.router.navigate([url, columnData.id || columnData.campaign_id || columnData.guid]);
  }

}